import { customizeError, formatDate } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { REACT_APP_SEARCH_DETAILS_PURCHASE_ORDER_URL } from '../../config/settings/environment'
import { getEncryptOrderNumber } from '../../services/buyer'
import { getListOfDemands, getTotalDemands } from '../../services/demandsTCP'

export const GET_TOTAL_DEMANDS = 'GET_TOTAL_DEMANDS'
export const GET_TOTAL_DEMANDS_ERROR = 'GET_TOTAL_DEMANDS_ERROR'
export const GET_TOTAL_DEMANDS_SUCCESS = 'GET_TOTAL_DEMANDS_SUCCESS'
export const onGetTotalDemands = makeActionCreator(GET_TOTAL_DEMANDS)
export const onGetTotalDemandsError = makeActionCreator(GET_TOTAL_DEMANDS_ERROR, 'payload')
export const onGetTotalDemandsSuccess = makeActionCreator(GET_TOTAL_DEMANDS_SUCCESS, 'payload')
export const onGetTotalDemandsThunk = payload => async dispatch => {
  dispatch(onGetTotalDemands())

  try {
    const { data } = await getTotalDemands({ actionType: GET_TOTAL_DEMANDS, dni: payload })

    return dispatch(
      onGetTotalDemandsSuccess({
        totalDemands: data?.payload?.total,
        initialDate: data?.payload?.fechaInicio,
        finalDate: data?.payload?.fechaFinal
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetTotalDemandsError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}

export const GET_LIST_OF_DEMANDS = 'GET_LIST_OF_DEMANDS'
export const GET_LIST_OF_DEMANDS_ERROR = 'GET_LIST_OF_DEMANDS_ERROR'
export const GET_LIST_OF_DEMANDS_SUCCESS = 'GET_LIST_OF_DEMANDS_SUCCESS'
export const onGetLisOfDemands = makeActionCreator(GET_LIST_OF_DEMANDS)
export const onGetLisOfDemandsError = makeActionCreator(GET_LIST_OF_DEMANDS_ERROR, 'payload')
export const onGetLisOfDemandsSuccess = makeActionCreator(GET_LIST_OF_DEMANDS_SUCCESS, 'payload')
export const onGetLisOfDemandsThunk = payload => async dispatch => {
  dispatch(onGetLisOfDemands())

  try {
    const { data } = await getListOfDemands({ actionType: GET_LIST_OF_DEMANDS, dni: payload })

    const gridData = data?.payload?.map(demand => ({
      ROLE: demand?.codigoDemanda,
      process: demand?.codigoMecanismo,
      date: formatDate(new Date(demand?.fechaIngresoDemanda), 'dd-MM-yyyy'),
      demanding: demand?.nombreDemandante,
      url: demand?.tipoMecanismo?.enlace
    }))
    const excelData = gridData.map(item => {
      return {
        ROL: item.ROLE,
        'Proceso de Compra': item.process,
        'Fecha de ingreso': item.date,
        Demandante: item.demanding
      }
    })

    return dispatch(
      onGetLisOfDemandsSuccess({
        gridData,
        excelData
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetLisOfDemandsError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}

export const GET_ENCRYPT_PURCHASE_DEMANDS = 'GET_ENCRYPT_PURCHASE_DEMANDS'
export const GET_ENCRYPT_PURCHASE_DEMANDS_ERROR = 'GET_ENCRYPT_PURCHASE_DEMANDS_ERROR'
export const GET_ENCRYPT_PURCHASE_DEMANDS_SUCCESS = 'GET_ENCRYPT_PURCHASE_DEMANDS_SUCCESS'
export const onGetEncryptPurchaseDemands = makeActionCreator(GET_ENCRYPT_PURCHASE_DEMANDS)
export const onGetEncryptPurchaseDemandsError = makeActionCreator(GET_ENCRYPT_PURCHASE_DEMANDS_ERROR, 'payload')
export const onGetEncryptPurchaseDemandsSuccess = makeActionCreator(GET_ENCRYPT_PURCHASE_DEMANDS_SUCCESS, 'payload')
export const onGetEncryptPurchaseDemandsThunk = payload => async dispatch => {
  dispatch(onGetEncryptPurchaseDemands())

  try {
    const { data } = await getEncryptOrderNumber({
      actionType: GET_ENCRYPT_PURCHASE_DEMANDS,
      orderNumber: payload.id
    })
    window.open(`${REACT_APP_SEARCH_DETAILS_PURCHASE_ORDER_URL}?qs=${data?.payload?.encrypt}`, 'Ficha_Compra')

    return dispatch(
      onGetEncryptPurchaseDemandsSuccess({
        encrypt: data?.payload?.encrypt
      })
    )
  } catch (error) {
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }
    return dispatch(
      onGetEncryptPurchaseDemandsError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
